import items from './items'

export const itemsService = items
